import { render, staticRenderFns } from "./MassMessageStatItem.vue?vue&type=template&id=96b6a396&scoped=true&"
import script from "./MassMessageStatItem.vue?vue&type=script&lang=ts&"
export * from "./MassMessageStatItem.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageStatItem.vue?vue&type=style&index=0&id=96b6a396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b6a396",
  null
  
)

export default component.exports